// Libraries
import {Tooltip as ReactTooltip} from 'react-tooltip';
import { Icon } from "@iconify/react";
import sunIcon from '@iconify-icons/feather/sun';
import moonIcon from '@iconify-icons/feather/moon';
import Select from 'react-select'
import { getLanguage, setLanguage, useTranslation } from 'react-multi-lang';

import KSA from '../../assets/images/logo/ksa.png'
import En from '../../assets/images/logo/gb.png'

import React, { HTMLInputTypeAttribute, useRef, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/en"; // you can change locale if needed
// Helpers
import { uid } from '../../services/hoc/helpers';

// Stylesheet
import './FormElements.css'

import { Tooltip } from '@mui/material';



export const DateInput =(props:any)=>{

    const [date, setDate] = useState<dayjs.Dayjs | null>(dayjs());

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
      <div className='input-box' style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1rem" }}>
        <DatePicker
          label={props.label}
          value={date}
          
          onChange={(newDate) => setDate(newDate)}
          format="YYYY/MM/DD" // <--- custom format here
        
          slotProps={{
            textField:{
                variant: 'outlined',
                size: 'small',
                fullWidth: true,
            }
          }

          }
        />

       
      </div>
    </LocalizationProvider>
  );
}



export const InputField = (props:any) => {
 
    let field: object = (({ type, onChange, defaultValue, disabled, max, min, value ,step,name,onBlur,onFocus,inputRef}) =>
         ({ onBlur,type, onChange, defaultValue, disabled, maxLength:max?max.toString():'', min, value,step,name,onFocus ,ref:inputRef}))(props);
    let inputLabel: string = props.placeholder ? props.placeholder : props.label ? props.label : '';
    let id = uid('input')

//!Boolean(props.value)
    return (
        <Tooltip
        title={props.error}
    
        placement='top'
        open={Boolean(props.error)}
        style={{background:'red'}}
        componentsProps={{
            tooltip: {
              sx: {
              backgroundColor:'white',
              borderColor:'red',
              color:'red',
              border:'1px solid',
              '& .MuiTooltip-arrow': {
                color: 'red',
                background:'red'
              },
              },
            },
          }}

        >
        <div className={`input-box ${props.type && props.type==='date'? 'date':''}`}
        style={props.style} >

            {
                props.type === 'date'?
                <input type='date' {...field } id = {id}/>
                :
                <input {...field} autoComplete="" id={id} />
                }
            {inputLabel &&true  ? <label className={props.value || props.value ===0 ? "active" : ''} htmlFor={id}>{inputLabel}</label> : ''}
            {props.error ? <i className="icon-error" data-tip={props.error}></i> : ''}
            {props.prefix?<span className={`prefix ${getLanguage()}`}>{props.prefix} </span>:''}
            {props.error ? <ReactTooltip place="left" variant="error"  delayHide={500} /> : ''}
        </div>
        </Tooltip>
    )

}

export const Textarea = (props: any) => {
    let field: object = (({ onChange, defaultValue, disabled, value, rows,name,onBlur ,style, }) => 
        ({ onBlur,name,onChange, defaultValue, disabled, value, rows ,style }))(props);
    let inputLabel: string = props.placeholder ? props.placeholder : props.label ? props.label : '';
    let id = uid('input')

    return (
        <div className="input-box textarea-box" style={props.container_style}>
            <textarea {...field} id={id}  />
            {inputLabel ? <label className={props.value ? "active" : ''} htmlFor={id}>{inputLabel}</label> : ''}
            {props.error ? <i className="icon-error" data-tip={props.error}></i> : ''}
            {props.error ? <ReactTooltip place="left" 
           
            
            delayHide={500} 
            variant={'error'}
            /> : ''}
        </div>
    )
}

export const Checkbox = (props: any) => {

    let field: object = (({ onChange, disabled, checked }) => ({ onChange, disabled, checked }))(props);
    let inputLabel: string = props.label;
    let id = uid('input')

    return (
        <div className="checkbox">
            <input {...field} type="checkbox" id={id} />
            <div>
                {inputLabel ? <label className={props.value ? "active" : ''} htmlFor={id}><i className="icon-checkmark" />{inputLabel}</label> : ''}
            </div>
        </div>
    )

}


export const SimpleCheckbox = (props: any) => {

    let field: object = (({ onChange, onClick, disabled, checked, className ,style}) => ({ onChange, onClick, disabled, checked, className ,style}))(props);
    let id = uid('input')

    return (
        <div className="simple-checkbox" style={props.style}>
            <input type="checkbox" id={id} {...field} />
            <label htmlFor={id} ><i className="icon-checkmark" />{props.label ? " " + props.label : ""}</label>
        </div>
    )

}


export const LightDarkModeSwitcher = (props: any) => {

    const changeMode = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            document.body.classList.add('dark')
            localStorage.setItem("theme", 'dark')
        }
        else {
            document.body.classList.remove('dark')
            localStorage.setItem("theme", 'light')
        }
    }

    return (
        <label style={{ cursor: 'pointer' ,display: 'inline-block',}}>
            <input className='toggle-checkbox' type='checkbox' onChange={changeMode} defaultChecked={localStorage.getItem("theme") ? localStorage.getItem("theme") === 'dark' : false}></input>
            <div className='toggle-slot'>
                <div className='sun-icon-wrapper'>
                    <Icon icon={sunIcon} className="sun-icon" />
                </div>
                <div className='toggle-button'></div>
                <div className='moon-icon-wrapper'>
                    <Icon icon={moonIcon} className="moon-icon" />
                </div>
            </div>
        </label>
    )

}


export const LanguageSwitcher = (props: any) => {
    const changeLang = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            setLanguage('ar')
            document.body.classList.add('rtl')
            localStorage.setItem("lang", "ar")
        }
        else {
            setLanguage('en')
            document.body.classList.remove('rtl')
            localStorage.setItem("lang", "en")
        }
    }

    return (
        <label style={{ display: 'inline-block', cursor: 'pointer' }} className="language-toggle">
            <input className='toggle-checkbox' type='checkbox' onChange={changeLang} 
            defaultChecked={localStorage.getItem("lang") ? localStorage.getItem("lang") === 'ar' : false}></input>
            <div className='toggle-slot'>
                <div className="ar">
                <img src={En} className='small-icon' />
                </div>
                <div className='toggle-button'></div>
                <div className="en">
                <img src={KSA} className="small-icon" />
                   
                </div>
            </div>
        </label>
    )

}


export const SelectField = (props: any) => {

    return (
        <div className="select-holder">
            <Select {...props} 
            className="react-select" 
            classNamePrefix="react-select"
             placeholder={props.label || props.placeholder}
            menuPortalTarget={document.body}
            menuShouldScrollIntoView={true}
            
            
            
            
             
             
             styles={
             {
                menuList(base, props) {
                    return ({
                        paddingBottom:'2rem',
                        maxHeight:'100px',
                        overflow:'hidden'
                    })
                },
                menuPortal:base=> ({...base ,zIndex:9999})
             }
             }/>
                
            {props.error ? <i className="icon-error" data-tip={props.error}></i> : ''}
            {props.error ? <ReactTooltip place="left" variant="error"  delayHide={500} /> : ''}
        </div>
    )

}





export const NumberField = (props: any) => {

    let field: object = (({ onChange, defaultValue, disabled, max, min, value ,error}) => ({ onChange, defaultValue, disabled, max, min, value ,error}))(props);
    let inputLabel: string = props.placeholder ? props.placeholder : props.label ? props.label : '';
    let id = uid('input')

    const [error, setError] = useState<string>("")

    const t = useTranslation()

    const enforceMinMax = (e: React.FocusEvent<HTMLInputElement>) => {

        if (e.currentTarget.value !== "") {

            if (parseInt(e.currentTarget.value) < parseInt(e.currentTarget.min)) {
                var nativeInputValueSetter = typeof window !== 'undefined' ? Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set : null;
                if (nativeInputValueSetter)
                    nativeInputValueSetter.call(e.currentTarget, e.currentTarget.min)
                var event = new Event('input', { bubbles: true })
                e.currentTarget.dispatchEvent(event)
            }

            if (parseInt(e.currentTarget.value) > parseInt(e.currentTarget.max)) {
                var nativeInputValueSetter = typeof window !== 'undefined' ? Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set : null;
                if (nativeInputValueSetter)
                    nativeInputValueSetter.call(e.currentTarget, e.currentTarget.max)
                var event = new Event('input', { bubbles: true })
                e.currentTarget.dispatchEvent(event)
            }
        }

    }

    const validate = (e: React.ChangeEvent<HTMLInputElement>) => {

        setError("")

        if (props.onChange)
            props.onChange(e)

        if (e.target.value !== "") {

            if (parseInt(e.target.value) < parseInt(e.target.min))
                setError(t("min_error", { value: e.target.min }))

            if (parseInt(e.currentTarget.value) > parseInt(e.currentTarget.max))
                setError(t("max_error", { value: e.target.max }))
        }

    }

    return (
        <div className={"input-box" + (props.className ? " " + props.className : "")}>
            <input {...field} value={props.value?.toString()} type="number" autoComplete="" id={id} onBlur={enforceMinMax} onChange={validate} />
            {inputLabel ? <label className={props.value || Number(props.value) === 0 ? "active" : ''} htmlFor={id}>{inputLabel}</label> : ''}
            {props.error || error ? <i className="icon-error" data-tip={error ? error : props.error}></i> : ''}
            {props.error || error ? <ReactTooltip place="left" variant="error" delayHide={500} /> : ''}
        </div>
    )
}

interface radioProps {
    name: string;
    onChange(e: React.ChangeEvent<HTMLInputElement>): any;
    disabled?: boolean;
    checked?: boolean;
    label?: string;
}

export const RadioButton = (props: radioProps) => {

    let id = uid('radio')

    return (
        <div className="radio-button">
            <input {...props} type="radio" id={id} />
            {props.label ? <label htmlFor={id}>{props.label}</label> : ''}
        </div>
    )

}

export const AnimationButton = (props: any) => {

    return (
        <button disabled={props.isLoading ||props.disabled} style={{ opacity: props.isLoading ? '0.3' : '1', cursor: props.isLoading ? 'wait' : 'pointer' }} {...props} className={"animation-btn " + props.className}><i className={props.icon}></i>{props.label}</button>
    )

}

export const GeneralButton = (props: any) => {
    return (
        <button disabled={props.isLoading} style={{ opacity: props.isLoading ? '0.3' : '1', cursor: props.isLoading ? 'wait' : 'pointer' }} {...props} className={"general-btn " + props.className}>
            {props.label}
        </button>
    )
}

export const CustomCheckbox = (props: any) => {

    let field: object = (({ onChange, disabled, checked }) => ({ onChange, disabled, checked }))(props);
    let inputLabel: string = props.label;
    let id = uid('input')
    return <div>
        <input {...field} className="custom-checkbox" id={id} type="checkbox" />
        <label htmlFor={id}>{inputLabel}</label>
    </div>
}
interface iSwitcher {first_choice:string,second_choice:string,handleChange:(value:boolean)=>void,value:boolean}
export  const Switcher =({first_choice,second_choice,handleChange,value}:iSwitcher)=>{
const onChange=(e:React.ChangeEvent<HTMLInputElement>)=>{
   
    handleChange(e.target.checked)
}

    return (
        <label style={{  cursor: 'pointer' }} className="swithcer_container">
            <input className='toggle-checkbox' type='checkbox' 
            onChange={onChange}
            checked={value}
            
          ></input>
            <div className='toggle-slot'>
                <div className="choice_first">{first_choice}</div>
                <div className='toggle-button'></div>
                <div className='toggle-button-track'></div>
                <div className="choice_second">{second_choice}</div>
            </div>
        </label>
    )
}


export const SmartInput =  (props:React.ComponentProps<'input'>)=>{
    
    const [selectAll , setSelectAll] = useState(true)
    let input_ref:HTMLElement|null=  document.getElementById(`smart_input_${props.name}`)

    const  isPureNumber=(str:string) =>{
  return /^[0-9]+$/.test(str);
}   

    const handleClick=(e:React.MouseEvent)=>{
       if (!selectAll) return 
       if (input_ref)
       (input_ref as HTMLInputElement)?.select()
    }
    
    const handleDoubleClick=(e:React.MouseEvent)=>{
        setSelectAll(false)
        setTimeout(()=>setSelectAll(true),500)
    }

    const handleChange = (e:React.ChangeEvent<HTMLInputElement>)=>{
       
        if (props.type === 'number') {
            
            if (!isPureNumber(e.target.value)) {
              
                if (e.target.value ===undefined) e.target.value=''
                else {
                    return
                }
            }
                
        }
       if(props.onChange) props.onChange(e)
    }
    return (
        <input
        id ={`smart_input_${props.name}`}
         onClick={handleClick} 
         onChange={handleChange}
         onDoubleClick={handleDoubleClick}
         type='text'
         {...props} />
    )


}